import React from "react";
import "../styles/Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWhatsapp,
  faTiktok,
  faFacebookF,
  faInstagram,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import logo from "../assets/images/logo.gif";
import { Link } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { FaPhone } from "react-icons/fa6";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          <h3>IT Solutions</h3>
          <p>Your partner in digital growth and innovation.</p>
          <div className="logo-section">
            <Link to="/" className="logo-link">
              <img src={logo} alt="Company Logo" className="navbar-logo" />
            </Link>
            <div className="brand-text">
              <h1 className="brand-name">ULTERSPACE </h1>
              <p className="slogan">Technological innovation</p>
            </div>
          </div>
        </div>
        <div>
          <h4>Quick Links</h4>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/packages">Packages</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/contact">Contact</Link>
            </li>
          </ul>
        </div>
        <div className="hours-container">
          <h4>Operating Hours</h4>
          <ul>
            <li>Mon – Fri: 08:00 – 18:00</li>
            <li>Sat – Sun: 10:00 – 18:00</li>
          </ul>
        </div>
        <div>
          <div className="contact-container">
            <h4>Contact Us</h4>
            <p>
              <MdEmail className="icon" /> ulterspace@gmail.com
            </p>
            <p>
              <FaPhone className="icon" /> +2783-224-8608
            </p>
          </div>
          <div className="social">
            {/* faTiktok */}
            <a
              href="https://wa.me/0760448944"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "35px",
                height: "35px",
                backgroundColor: "white",
                borderRadius: "8px",
                color: "black",
                fontSize: "25px",
                textDecoration: "none",
                margin: "0 5px",
              }}
            >
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            {/* faTiktok */}
            <a
              href="https://www.tiktok.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "35px",
                height: "35px",
                backgroundColor: "white",
                borderRadius: "8px",
                color: "black",
                fontSize: "25px",
                textDecoration: "none",
                margin: "0 5px",
              }}
            >
              <FontAwesomeIcon icon={faTiktok} />
            </a>

            {/* Facebook */}
            <a
              href="https://www.facebook.com/ulterspace"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "35px",
                height: "35px",
                backgroundColor: "white",
                borderRadius: "8px",
                color: "black",
                fontSize: "25px",
                textDecoration: "none",
                margin: "0 5px",
              }}
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            {/* Instagram */}
            <a
              href="https://www.instagram.com/ulterspace"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "35px",
                height: "35px",
                backgroundColor: "white",
                borderRadius: "8px",
                color: "black",
                fontSize: "25px",
                textDecoration: "none",
                margin: "0 5px",
              }}
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            {/* X (Twitter) */}
            <a
              href="https://www.x.com/ulterspace_net"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "35px",
                height: "35px",
                backgroundColor: "white",
                borderRadius: "8px",
                color: "black",
                fontSize: "25px",
                textDecoration: "none",
                margin: "0 5px",
              }}
            >
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} Ulterspace. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
